import Settings from '../olr-common/Settings';

export default function IdentityMgmtService($http) {

  this.getAuth = function(email) {
    let url = Settings.backendEnv + "/api/v1/idmgmt";
    var req = {
      method: "GET",
      url:    url+'/'+email
    };

    return $http(req);
  };
}


/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/IdentityMgmtService.js
 **/